// =========================================================
// 1. UPSELL: Fetch + Add-to-Cart con apertura del carrito lateral
// =========================================================
document.addEventListener("DOMContentLoaded", function() {
  const upsellContainer = document.querySelector('.vertical-upsell-container');
  if (upsellContainer) {
    const url = upsellContainer.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const newContent = html.querySelector('.vertical-upsell-container');
        if (newContent && newContent.innerHTML.trim().length > 0) {
          upsellContainer.innerHTML = newContent.innerHTML;
          
          // Elimina cart-drawer duplicado si se coló dentro del contenido del upsell
          const nestedDrawer = upsellContainer.querySelector('cart-drawer');
          if (nestedDrawer) nestedDrawer.remove();

          // Script blindado que procesa la compra y abre el carrito lateral
          const forms = upsellContainer.querySelectorAll('.custom-upsell-form');
          forms.forEach(form => {
            form.addEventListener('submit', function(e) {
              e.preventDefault();
              const btn = form.querySelector('.upsell-add-btn');
              const spinner = btn?.querySelector('.spinner');
              const contentWrapper = btn?.querySelector('.btn-content-wrapper');

              // Estado de carga
              btn.disabled = true;
              if (spinner) spinner.classList.remove('hidden');
              if (contentWrapper) contentWrapper.style.visibility = 'hidden';

              const formData = new FormData(form);
              // Busca el cart-drawer principal en la raíz del DOM
              const cartDrawer = document.querySelector('body > cart-drawer') || document.querySelector('cart-drawer');

              if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
                formData.append('sections', cartDrawer.getSectionsToRender().map(s => s.id).join(','));
                formData.append('sections_url', window.location.pathname);
              }

              fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
                method: 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: formData
              })
              .then(res => res.json())
              .then(res => {
                if (res.status) { 
                  alert(res.description); 
                  return; 
                }

                if (cartDrawer) {
                  // Renderiza contenidos e inhabilita estado de carrito vacío
                  cartDrawer.renderContents(res); 
                  cartDrawer.classList.remove('is-empty');

                  // Invocación explícita para desplegar el drawer
                  if (typeof cartDrawer.open === 'function') {
                    cartDrawer.open();
                  } else {
                    cartDrawer.classList.add('animate', 'active');
                  }
                } else {
                  window.location.href = '/cart';
                }
              })
              .catch(err => console.error("Error al añadir producto:", err))
              .finally(() => {
                btn.disabled = false;
                if (spinner) spinner.classList.add('hidden');
                if (contentWrapper) contentWrapper.style.visibility = 'visible'; 
              });
            });
          });
        }
      })
      .catch(e => console.error("Error cargando upsell:", e));
  }
});

// =========================================================
// 2. MOBILE SLIDER: Contador personalizado "1 / N"
// =========================================================
document.addEventListener("DOMContentLoaded", function() {
  // Solo ejecutar en móvil
  if (window.innerWidth > 749) return;

  const wrapper = document.querySelector('.product__media-wrapper');
  if (!wrapper) return;

  const slider = wrapper.querySelector('.slider.slider--mobile'); // El carrusel
  const buttonsContainer = wrapper.querySelector('.slider-buttons');
  
  // Si no encuentra los elementos, salimos
  if (!slider || !buttonsContainer) return;

  const items = slider.querySelectorAll('li.product__media-item');
  const totalItems = items.length;
  if (totalItems === 0) return;

  // 1. Crear el elemento contador
  const counterEl = document.createElement('span');
  counterEl.className = 'custom-mobile-counter';
  counterEl.innerText = `1 / ${totalItems}`;

  // 2. Insertar el contador entre los botones (Botón prev -> Contador -> Botón next)
  const nextBtn = buttonsContainer.querySelector('button[name="next"]');
  if (nextBtn) {
    buttonsContainer.insertBefore(counterEl, nextBtn);
  } else {
    buttonsContainer.appendChild(counterEl);
  }

  // 3. Detectar el scroll para actualizar el número (1/8, 2/8, etc.)
  let isScrolling;
  slider.addEventListener('scroll', function() {
    window.clearTimeout(isScrolling);
    isScrolling = setTimeout(function() {
      const slideWidth = items[0].clientWidth;
      const scrollPos = slider.scrollLeft;
      // Calculamos índice actual basado en el scroll
      const currentIndex = Math.round(scrollPos / slideWidth) + 1;
      
      // Aseguramos que no se pase del total
      const finalIndex = Math.min(Math.max(currentIndex, 1), totalItems);
      
      counterEl.innerText = `${finalIndex} / ${totalItems}`;
    }, 60); // Pequeño delay para rendimiento
  });
});
